import Datapoint from 'owa-service/lib/contract/Datapoint';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';

export interface InlineFeedbackDialogLogDataPointProps {
    sessionId: string;
    inlineFeedbackResponseText: string;
    inlineFeedbackResponseCategories: string[];
    isContentDonated: boolean;
    isUVTicketCreated: boolean;
}

export function sendInlineFeedbackDialogDatapoint(
    datapointProps: InlineFeedbackDialogLogDataPointProps
): Promise<boolean> {
    const keys: string[] = ['fdsid', 'fdt', 'fdc', 'fdicd', 'fduvt'];

    let values: string[] = [
        datapointProps.sessionId,
        datapointProps.inlineFeedbackResponseText,
        datapointProps.inlineFeedbackResponseCategories.join(' | '),
        datapointProps.isContentDonated ? 'Yes' : 'No',
        datapointProps.isUVTicketCreated ? 'Yes' : 'No',
    ];

    let feedbackLogDatapoint: Datapoint = {
        Id: 'InlineFeedbackDialog',
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };

    return logDatapointOperation({ datapoints: [feedbackLogDatapoint] });
}
